import ApiFactory from '@/factories/ApiFactory'
import { serialize } from '@/utilities/querySerialize'

export default {
  list(query) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/clients?${serialize(query)}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  details(id) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/clients/${id}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  create(payload) {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/clients', payload)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  update(payload) {
    return new Promise((resolve, reject) => {
      let id = payload.id
      ApiFactory.put(`v1/clients/${id}`, payload)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      ApiFactory.delete(`v1/clients/${id}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
}
